import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { HiOutlineDownload } from "react-icons/hi";
import { FiTrash2 } from "react-icons/fi";
import Select from "react-select";
import MainLayout from "../../../components/MainLayout";
import { TbClipboardCheck, TbLoader } from "react-icons/tb";
import BadgePills from "../../../components/BadgePills";
import AgenteStatus from "../../../helpers/AgenteStatus";
import Swal from "sweetalert2";
import { getAllUsersAgencia, deleteOneUserAgencia } from "../../../helpers/Api";
import ListDeuda from "../../../helpers/ListDeuda";
import TabAdminAaaver from "../ListadoAgentes/TabAdminAaaver";
import {ASOCIACION_USER} from "../../../constants";

const ListadoAgentes = () => {

  //Loading state
  const [loading, setLoading] = useState(true);
  
  //Credencials
  const token = localStorage.getItem("token");
  const role = localStorage.getItem('role');

  const [agentesData, setAgentesData] = useState([]);
  const [tableItemsCounter, setTableItemsCounter] = useState('');

  //search
  const [searchParam, setSearchParam] = useState("");
  const [estatus, setEstatus] = useState('');
  const [searchDebt, setSearchDebt ] = useState("");

  //pagination
  const itemsPerPage = 5;
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const BASE_URL = process.env.REACT_APP_API;

  useEffect(() => {
    getAllAgentes();
  }, [itemOffset, 
    searchParam,
    estatus,
    searchDebt,
  ]);

  const getAllAgentes = async () => {
    try {
      const response = await getAllUsersAgencia(
        itemsPerPage,
        itemOffset,
        searchParam,
        searchDebt,
        token,
        estatus,
      );
      if (response) {
        response?.count === itemsPerPage
          ? setPageCount(1)
          : setPageCount(Math.ceil(response?.count / itemsPerPage));
        setAgentesData(response.results);
        setTableItemsCounter(response.count)
      }
    } catch (error) {
      throw error;
    }
    finally {
      setLoading(false);
    }
  };

  const handlePageClick = (event) => {
    setItemOffset(event.selected * itemsPerPage);
  };

  //SEARCHERS
  const handlerWordSearch = (e) => {
    setSearchParam(e.target.value);
  };

  const handlerEstatus = (e) => {
    setEstatus(e === null ? '' : e.value);
  };

  const handlerDeudaEstatus = (e) => {
    setSearchDebt(e === null ? '' : e.value);
  };


  const downLoadReporteUsuarios = () => {
    fetch(`${BASE_URL}/generar-reporte-usuarios/`, {
      headers: {
        Authorization: `Token ${token}`,
      }
    }).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "reporte-usuarios.xlsx";
        a.click();
      });
    });
  };


  const downLoadReporteAgencia = () => {
    fetch(`${BASE_URL}/api/v1/generar-reporte-agentes/`, {
      headers: {
        Authorization: `Token ${token}`,
      }
    }).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "reporte-listado-agencias-aduanales.xlsx";
        a.click();
      });
    });
  };

  const handlerDeleteAgente = async (idAgente) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Una vez eliminado, no podrás recuperar la información del agente",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await deleteOneUserAgencia(idAgente, token);
          if (!response) {
            Swal.fire("Exito", "El agente ha sido borrado exitosamente ", "success");
            getAllAgentes();
          }
        } catch (error) {
          Swal.fire(
            "Oops",
            "Ha surgido un problema al eliminar el agente",
            "error"
          );
        }
      }
    });
  };

  return (
    <MainLayout>
      <div className="row title_layout">
        <div className="col-6">
          <h5>LISTA DE SOCIOS</h5>
        </div>
        <div className="col-6 d-flex flex-row-reverse">
          <TabAdminAaaver />
        </div>
      </div>

      <div className="row table_body">
      { loading ? (
          <div className="d-flex justify-content-center" style={{marginTop: '4rem'}}>
              <TbLoader color={'rgb(10, 132, 254)'} className="loader" size={'3rem'}/>
          </div>
        ) : (
        <>
          <div className="row table_searchers">
            <div className="col-4 d-flex justify-content-start">

              {role !== 'NUS' &&
                <Link to="/crear-perfil-agente">
                  <button className="btn principal_button">
                    + Registrar Agente Aduanal
                  </button>
                </Link>
              }
            </div>
            <div className="col-8 d-flex justify-content-end"
                 style={{marginBottom: '1rem'}}>

              { role === ASOCIACION_USER &&
              <button onClick={() => downLoadReporteUsuarios()}
                      className="btn lean_button">
                <HiOutlineDownload style={{marginRight: '10px'}}/>
                Descargar Usuarios
              </button>}
              <button onClick={() => downLoadReporteAgencia()}
                      className="btn lean_button ms-2">
                <HiOutlineDownload style={{marginRight: '10px'}}/>
                Descargar Agencias Aduanales
              </button>
            </div>
            <hr style={{borderTop: "dotted 1px"}}/>
            <div className="col-4 d-flex justify-content-end">
              <input
                className="form-control"
                type="search"
                value={searchParam}
                onChange={handlerWordSearch}
                placeholder="Buscar por nombre de agente aduanal"
                aria-label="Search"
                style={{width: "100%"}}
              />
            </div>
            <div className="col-4">
              <Select
                className="basic-single"
                classNamePrefix="select"
                name="filtro_estatus"
                options={AgenteStatus}
                onChange={(e) => handlerEstatus(e)}
                placeholder={"Filtro por estatus"}
                isClearable={true}
              />
            </div>
            <div className="col-4">
              <Select
                className="basic-single"
                classNamePrefix="select"
                name="color"
                options={ListDeuda}
                onChange={(e) => handlerDeudaEstatus(e)}
                placeholder={"Buscar por nivel de deuda"}
                isClearable={true}
              />
            </div>

            <hr style={{borderTop: "dotted 1px", marginTop: "1rem"}}/>
          </div>
          <div className="col-12 table-responsive">
            <div className="col-12" style={{textAlign: 'center', marginTop: '2rem'}}>
              <p>Total de registros: {tableItemsCounter}</p>
            </div>
            <table className="table">
              <thead>
              <tr>
                <th scope="col">Patente</th>
                <th scope="col">Agente Aduanal</th>
                <th scope="col">Correo</th>
                <th scope="col">Adeudo</th>
                <th scope="col">Estatus</th>
                <th scope="col">Vencimiento</th>
                <th scope="col">Acciones</th>
              </tr>
              </thead>
              {agentesData?.map((value, index) => (
                <tbody key={index}>
                <tr>
                  <td style={{paddingTop: '3.1rem'}}>{value.patente}</td>
                  <td style={{paddingTop: '3.1rem'}}>{value.nombre}</td>
                  <td style={{paddingTop: '3.1rem'}}>{value.correo_contacto}</td>
                  <td style={{paddingTop: '3.1rem'}}>{
                    value.estado_deuda === 'BAJ' ?
                      <BadgePills status={value.estado_deuda}
                                  amount={value.total_deuda}/> :
                      value.estado_deuda === 'MED' ?
                        <BadgePills status={value.estado_deuda}
                                    amount={value.total_deuda}/> :
                        value.estado_deuda === 'ALT' ?
                          <BadgePills status={value.estado_deuda}
                                      amount={value.total_deuda}/> :
                          value.estado_deuda === 'MAL' ?
                            <BadgePills status={value.estado_deuda}
                                        amount={value.total_deuda}/> :
                            null
                  }</td>
                  <td style={{paddingTop: '3.1rem'}}>{
                    value.estado === "ACT" ? "Activo" :
                      value.estado === "ACD" ? "Activo con deuda" :
                        value.estado === "CPA" ? "Cedio patente" :
                            value.estado === "SAP" ? "Suspendido - AAAPVER" :
                              value.estado === "SAT" ? "Suspendido actividades" :
                                value.estado === "TRA" ? "En trámite" :
                                  value.estado === "FIN" ? "Finado" :
                                    ''
                  }</td>
                  <td style={{paddingTop: '3.1rem'}}>{value.fecha_vencimiento}</td>
                  <td className="d-flex flex-row" style={{height: '8.1rem'}}>
                    <button
                      style={{color: "#F34949"}}
                      className="btn d-flex align-items-center"
                      onClick={() => handlerDeleteAgente(value.id)}
                    >
                      <FiTrash2 size={'1.1rem'} style={{marginLeft: '10px'}}/>
                    </button>
                    <Link
                      className="btn d-flex align-items-center"
                      to={`/perfil-agente/${value.id}/#historico`}
                    >
                      <TbClipboardCheck style={{marginLeft: '0px'}} size={'1.1rem'}
                                        color={"#4516FF"}/>
                    </Link>
                  </td>
                </tr>
                </tbody>
              ))}
            </table>
          </div>
          <div className="row">
            <div className="col-12" style={{textAlign: 'center', marginTop: '2rem'}}>
              <p>Total de registros: {tableItemsCounter}</p>
          </div>
          <div className="col-12 d-flex justify-content-end paginationList">
            <ReactPaginate
              breakLabel="..."
              nextLabel="Siguiente"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="Anterior"
              renderOnZeroPageCount={null}
              containerClassName="pagination my-5 mx-auto"
              subContainerClassName="pages pagination"
              activeClassName="active"
              breakClassName="break-me"
              className="pagination"
            />
          </div>
        </div>
        </>
        )}
      </div>
    </MainLayout>
  );
};

export default ListadoAgentes;
